import { ApiKey } from "../common/request/apiKey";
import { useCachedApi } from "../common/request/useCachedApi";
import { GetInformationResponse } from "./types";

export const useGetNews = () => {
  const { data, error, isLoading } = useCachedApi<GetInformationResponse>({
    method: ApiKey.GET_INFORMATION,
  });
  return { data, error, isLoading };
};
